import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { AppContext, getClonedData, EMPTY_OBJECT } from 'commons-ui';
import useService from '../../utils/useService';
import { hydrateFormData, dehydrateFormData } from '../../utils/formDataParser';
import { FORM_FIELD_KEYS } from '../../utils/formConfig';
import { IConversionOffer, ISegmentOffer } from '../../utils/type';

const useClone = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history: any = useHistory();
	const location = useLocation();
	const { requestCreateOffer } = useService();

	const formDefaults = { validFrom: new Date().getTime(), validTill: new Date().getTime() };

	const CloneOffer = (conversionOffer: ISegmentOffer) => {
		setShowLoader(true);
		requestCreateOffer(app.appName, { ...conversionOffer }).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(`Error: ${res?.data?.error || 'Error occured while cloning the CTD offer'}`, { type: 'error' });
					setShowLoader(false);
				} else {
					showAlert('Offer Created');
					history.goBack();
				}
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: IConversionOffer) => {
		CloneOffer(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: {
			...hydrateFormData(getClonedData(_get(location, ['state', 'rowData'], EMPTY_OBJECT), FORM_FIELD_KEYS, formDefaults)),
			segmentList: history?.location?.state?.segmentList,
			mapValue: JSON.stringify(history?.location?.state?.mapValues)
		},
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useClone;
